<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import { apiService } from '@/helpers/api.service'
import moment from 'moment'
import Loader from '@/components/widgets/loader'
import Swal from "sweetalert2"
import { permissionsMap, checkPermission } from '@/utils/utilsPermissions';

export default {
    components: { Layout, PageHeader, Loader },
    props: {},
    data() {
        return {
            schedule: [{
                title: 'Domingo',
                hours: [{ open: '', close: '' }],
                closed: false,
                add: true
            },{
                title: 'Lunes',
                hours: [{ open: '', close: '' }],
                closed: false,
                add: true
            },
            {
                title: 'Martes',
                hours: [{ open: '', close: '' }],
                closed: false,
                add: true
            },

            {
                title: 'Miércoles',
                hours: [{ open: '', close: '' }],
                closed: false,
                add: true
            },

            {
                title: 'Jueves',
                hours: [{ open: '', close: '' }],
                closed: false,
                add: true
            },

            {
                title: 'Viernes',
                hours: [{ open: '', close: '' }],
                closed: false,
                add: true
            },

            {
                title: 'Sábado',
                hours: [{ open: '', close: '' }],
                closed: false,
                add: true
            },
            ],
            isLoading: true,
            store: null,
            specialWeekendPost: [{ index: '', name: '', date: '', hours: [{ open: '', close: '' }], back: false }],
            specialWeekend: [],
            validSpecialWeekend: true,
            addSpecialHours: false,
            validSchedule: true,
            validAddWeekend: true,
            daysOfWeek: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        };
    },
    watch: {
        schedule: {
            deep: true,
            handler() {
                this.validateSchedule();
            }
        },
        specialWeekend: {
            deep: true,
            handler() {
                this.validateSpecialSchedule();
            }
        },
        specialWeekendPost: {
            deep: true,
            handler() {
                this.validateAddWeekend();
            }
        }
    },
    computed: {
    },
    created: () => {
    },
    methods: {
        canEditSchedule() {
            return checkPermission(permissionsMap.UPDATE_STORE_SCHEDULE, this.$store.state.permissions);
        },
        canEditSpecialSchedule() {
            return checkPermission(permissionsMap.UPDATE_STORE_WEEKEND, this.$store.state.permissions);
        },
        canCreateSpecialSchedule() {
            return checkPermission(permissionsMap.CREATE_STORE_WEEKEND, this.$store.state.permissions);
        },
        canViewSchedule() {
            return checkPermission(permissionsMap.READ_STORE_SCHEDULE, this.$store.state.permissions);
        },
        canEnableSchedule() {
            return checkPermission(permissionsMap.UPDATE_STORE_SCHEDULE, this.$store.state.permissions);
        },
        canDeleteSpecialSchedule() {
            return checkPermission(permissionsMap.DELETE_STORE_WEEKEND, this.$store.state.permissions);
        },
        ModalAddWeekend(index) {
            if (!index) {
                this.addSpecialHours = false;
                this.specialWeekendPost = [{ index: '', name: '', date: '', hours: [{ open: '', close: '' }], back: false }];
                this.isLoading = false;
                return;
            }

            this.addSpecialHours = true;
            this.isLoading = true;

            apiService.deleteSpecialWeekend(index)
            .then(() => {
                window.location.reload();
            })
            .catch(() => {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Ocurrió un error al eliminar el horario.",
                    showConfirmButton: false,
                    timer: 4500
                });
            })
                .finally(() => {
                    this.addSpecialHours = false;
                    this.specialWeekendPost = [{ index: '', name: '', date: '', hours: [{ open: '', close: '' }], back: false }];
                    this.isLoading = false;
                });
        },


        validateSchedule() {
            this.validSchedule = this.schedule.every(day => {
                if (day.closed) return true;
                return day.hours.every(hour => hour.open < hour.close);
            });
        },
        openModal(index) {
            const selectedDay = this.specialWeekend.find(day => day.index == index);
            if (selectedDay) {
                this.specialWeekendPost.shift();
                this.specialWeekendPost.push({
                    id: selectedDay.id,
                    name: selectedDay.name,
                    date: this.formatDateToYYYYMMDD(selectedDay.date),
                    hours: selectedDay.hours.map(hour => ({ open: hour.open, close: hour.close })),
                    back: true
                });
            }
            this.addSpecialHours = true
        },
        formatDateToYYYYMMDD(date) {
        return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    },
        getSchedules() {
            apiService.getSchedule()
                .then(res => {
                    if (res && res.schedule && res.schedule.length > 0) {
                        this.schedule = res.schedule.map(day => ({
                            title: this.daysOfWeek[day.day],
                            hours: day.hours.map(hour => ({ open: hour.open, close: hour.close })),
                            closed: !day.isAvailable,
                            add: true
                        }));
                    } else {
                        this.validSchedule = false;
                    }
                    if (res && res.weekend.length > 0) {
                        this.specialWeekend = res.weekend.map((day, index) => {
                            return ({
                            id: day._id,
                            name: day.name || '',
                            date: day.hours.length > 0 ? moment.utc(day.hours[0].open).format('DD/MM/YYYY') : '',
                            hours: res.weekend[index].hours.length > 0 ? day?.hours.map(hour => ({ open: moment.utc(hour?.open).format('HH:mm'), close: moment.utc(hour?.close).format('HH:mm') })) : [{ open: '', close: '' }],
                            index: index
                        })
                        })
                    }
                })
                .catch(error => {
                    console.error('Error al obtener los horarios:', error);
                }).finally(() => {
                    this.isLoading = false
                });
        },
        validateSpecialSchedule() {
            this.validSpecialWeekend = this.specialWeekend.every(day => {
                if (day.closed) return true;

                const openTime = moment(day.open, 'HH:mm');
                const closeTime = moment(day.close, 'HH:mm');

                return openTime.isBefore(closeTime);
            });
        },
        validateAddWeekend() {
            this.validAddWeekend = this.specialWeekendPost.every(post => {
                return post.hours.every(day => {
                    if (day.closed) return true;

                    const postDate = moment(post.date).format('YYYY-MM-DD');
                    const currentDate = moment.utc().format('YYYY-MM-DD');

                    if (postDate.isBefore(currentDate)) return false;


                    const openTime = moment(day.open, 'HH:mm');
                    const closeTime = moment(day.close, 'HH:mm');


                    return openTime.isBefore(closeTime);
                });
            });
        },
        addHour(index) {
            if (this.schedule[index].hours.length < 4) {
                this.schedule[index].hours.push({ open: '', close: '' });
            } else {
                alert('Solo puedes agregar un máximo de 4 horarios.');
            }
        },
        addSpecialHoursList(index) {
            this.addSpecialHours = true
            this.specialWeekend[index].hours.push({ from: '', to: '' });
        },
        removeSpecialHoursList(dayIndex, hourIndex) {
            this.specialWeekend[dayIndex].hours.splice(hourIndex, 1);
        },
        addHourWeekend(index) {
            this.specialWeekendPost[index].hours.push({ from: '', to: '' });
        },
        removeHour(dayIndex, hourIndex) {
            this.schedule[dayIndex].hours.splice(hourIndex, 1);
        },
        removeHourWeekend(dayIndex, hourIndex) {
            this.specialWeekendPost[dayIndex].hours.splice(hourIndex, 1);
        },
        postSchedule() {
            this.isLoading = true
            let updatedSchedule = {
                schedule: this.schedule.map((day, index) => {
                    let hours = day.hours && day.hours.length > 0
                        ? day.hours.map(hour => ({
                            open: hour.open,
                            close: hour.close
                        }))
                        : [];
                    if (day.closed === true && (hours.length === 0 || hours.some(h => !h.open || !h.close))) {
                        hours = [{ open: '09:00', close: '21:00' }];
                    }
                    return {
                        day: index,
                        hours,
                        isAvailable: !day.closed
                    };
                })
            };
            apiService.putSchedule(updatedSchedule)
                .then(async(res) => {
                    if (res) {
                        await this.getSchedules()
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Guardado con éxito.",
                            showConfirmButton: false,
                            timer: 4500
                        });
                        this.isLoading = false
                    }
                    else {
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Error al guardar.",
                            showConfirmButton: false,
                            timer: 4500
                        });
                        this.isLoading = false
                    }
                })
                .catch(() => {
                    Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Error al guardar.",
                            showConfirmButton: false,
                            timer: 4500
                        });
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        formatTitleCase (str) {
        if (!str) return;
        return str
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
        },
        postWeekend() {
            this.isLoading = true
            let updatedSpecialWeekend = {
                weekend: {
                    name: this.specialWeekendPost[0].name,
                    hours: this.specialWeekendPost[0].hours.map(hour => ({
                        open: this.formatDateTime(this.specialWeekendPost[0].date, hour.open),
                        close: this.formatDateTime(this.specialWeekendPost[0].date, hour.close)
                    }))
                }
            };
            const specialWeekendId = this.specialWeekendPost[0].id;
                (specialWeekendId 
                    ? apiService.postSpecialWeekendWithId(updatedSpecialWeekend, specialWeekendId)
                    : apiService.postSpecialWeekend(updatedSpecialWeekend)
                )
                .then(() => {
                        this.addSpecialHours = false
                        Swal.fire({
                                position: "center",
                                icon: "success",
                                title: "Guardado con éxito.",
                                showConfirmButton: false,
                                timer: 4500
                            });
                        window.location.reload();
                })
                .catch(() => {
                    Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Error al guardar.",
                            showConfirmButton: false,
                            timer: 4500
                        });
                })
                .finally(() => {
                    this.specialWeekendPost = [{ index: '', name: '', date: '', hours: [{ open: '', close: '' }], back: false }]
                    this.isLoading = false
                })
        },
        formatDateTime(date, time) {
            return moment.utc(`${date} ${time}`, 'YYYY-MM-DD HH:mm').toISOString(); 
        },
        handleKeyDown(event) {
            if (event.key === 'Escape') {
                this.addSpecialHours = false
                this.specialWeekendPost = [{ index: '', name: '', date: '', hours: [{ open: '', close: '' }], back: false }]
            }
        },
        dayDate(date) {
            const dataFormat = moment.utc(date, 'DD/MM/YYYY').format('DD/MM/YYYY');
            const dayNameInSpanish = moment.utc(dataFormat, 'DD/MM/YYYY').locale('es').format('dddd');
            const dayNameFormatted = dayNameInSpanish.charAt(0).toUpperCase() + dayNameInSpanish.slice(1);
            return dayNameFormatted;
        },
        truncateText(text, length) {
            if (text.length > length) {
                return text.substring(0, length) + '...';
            }
            return text;
        },
    },
    mounted() {
        this.getSchedules()
        const storeStorage = JSON.parse(localStorage.getItem('store'));
        this.store = storeStorage
        window.addEventListener('keydown', this.handleKeyDown);
        this.canEditSchedule()
        this.canEditSpecialSchedule()
        this.canCreateSpecialSchedule()
        this.canViewSchedule()
        this.canEnableSchedule()
    }, 
}
</script>

<template>
    <Layout>
        <Loader v-show="isLoading"></Loader>
        <PageHeader  />

        <div class="row justify-content-around" v-show="!isLoading" :style="{backgroundColor:'#FFFFF'}">

            <!-- schedule -->
            <div class="col-sm-12 col-md-6 schedules-custom-box">
                <div>
                    <p class="text-green schedule-title">Mis Horarios</p>
                </div>

                <div class="row" v-for="(day, index) in schedule" :key="index">
                    <div class="divider"></div>
                    <div class="schedule-grid">
                        <div class="schedule-day-info">
                            <div class="col-md-3 center day-switch">
                                <div class="form-check form-switch">
                                    <input class="form-check-input day-toggle" :disabled="!canEnableSchedule()" v-if="day.add" type="checkbox" role="switch" id="flexSwitchCheckChecked" :checked="!day.closed" @click="day.closed = !day.closed">
                                </div>
                                <div class="day-details">
                                    <p class="title-day-schedule">{{ day.title }}</p>
                                    <p class="title-day-schedule-open-close" v-if="day.add">{{ day.closed ? 'Cerrado' : 'Abierto' }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="schedule-hours">
                            <div v-for="(hour, hourIndex) in day?.hours" :key="hourIndex" class="schedule-container">
                                <div class="hour-entry">
                                    <div class="col-md-4 center hour-open" v-if="!day.closed">
                                        <div class="center hour-label">
                                            Abre
                                            <b-form-input  :disabled="!canEditSchedule()" type="time" min="0" class="input-schedule-2" v-model="hour.open"></b-form-input>
                                        </div>
                                    </div>
                                    <div class="col-md-4 center hour-close" v-if="!day.closed">
                                        <div class="center hour-label">
                                            Cierra
                                        </div>
                                        <b-form-input :disabled="!canEditSchedule()" type="time" class="input-schedule-3" v-model="hour.close"></b-form-input>
                                    </div>
                                    <!-- Boton de mas -->
                                    <div class="col-md-2 my-auto add-new-schedule" v-if="!day.closed" :style="{'opacity': canEditSchedule() ? 1 : 0}">
                                        <img @click="addHour(index)" src="@/assets/images/plus.png" alt="more" class="control-icon" />
                                        <img @click="removeHour(index, hourIndex)" v-if="hourIndex > 0" src="@/assets/images/Delete.png"
                                            alt="delete" class="control-icon delete-icon" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- SpeciaWeekend -->
            <div class="col-sm-12 col-md-6 schedules-custom-box-special">
                <div class="special-weekend-header">
                    <p class="text-green special-dates-title">Fechas especiales</p>
                    <p class="add-schedule-button" @click="addSpecialHours = true" v-if="canCreateSpecialSchedule()">+ Agregar horario</p>
                </div>

                <div class="divider"></div>

                <div v-if="addSpecialHours">
                    <div v-for="(day, index) in specialWeekendPost" :key="index">
                        <div class="special-day-name-container">
                            <label>Nombre del Día (opcional)</label>
                            <b-form-input type="text" min="0" maxlength="30" class="input-schedule input-schedule-open"  @input="day.name = formatTitleCase(day?.name)" v-model="day.name"></b-form-input>
                        </div>

                        <div class="date-hours-container">
                            <div class="date-container">
                                <label>Fecha</label>
                                <b-form-input type="date" min="0" max="9999-12-31" class="input-schedule input-schedule-open" v-model="day.date"></b-form-input>
                            </div>

                            <div class="hours-container">
                                <div v-for="(hours, hourIndex) in day?.hours" :key="hourIndex" class="hour-entry">
                                    <div class="hour-entry-row-special">
                                        <div>
                                            <label>Abre</label>
                                            <b-form-input type="time" min="0" class="input-schedule input-schedule-open" v-model="hours.open"></b-form-input>
                                        </div>
                                        <div>
                                            <label>Cierra</label>
                                            <b-form-input type="time" min="0" class="input-schedule input-schedule-open" v-model="hours.close"></b-form-input>
                                        </div>

                                        <div class="hour-entry-controls-special" v-if="!day.closed">
                                            <img @click="addHourWeekend(index)" src="@/assets/images/plus.png" alt="more" class="control-icon-special" />
                                            <img @click="removeHourWeekend(index, hourIndex)" :style="{'visibility': hourIndex > 0 ? 'visible' : 'hidden'}" src="@/assets/images/Delete.png" alt="delete" class="control-icon delete-icon" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="action-buttons">
                            <button @click="ModalAddWeekend(day.id)" class="delete-button" :style="{opacity: canDeleteSpecialSchedule() ? 1 : 0}" >Eliminar</button>
                            <b-button type="submit" :style="{opacity: canViewSchedule() ? 1 : 0}" variant="success" @click="postWeekend()" class="btn-success save-button" :disabled="!validAddWeekend">
                                Guardar Cambios
                            </b-button>
                        </div>
                        <div class="divider"></div>
                    </div>
                </div>

                <div v-if="specialWeekend.length == 0" class="no-specialWeekend">No se han registrado fechas especiales.</div>
                <div class="row" v-for="(day, index) in specialWeekend" :key="index">
                    <div class="col-md-5 center special-weekend-day">
                        <div class="special-day-info">
                            <div>
                                <p class="special-day-date">{{ dayDate(day.date) }} {{ day.date }} </p>
                                <p class="special-day-name">
                                    {{ truncateText(day.name, 20) }}
                                    <img v-if="canEditSpecialSchedule()" src="@/assets/images/edit.png" width="18" height="19" alt="more" class="edit-icon" @click="openModal(index)">
                                </p>
                            </div>
                        </div>
                    </div>

                    <div v-for="(hour, hourIndex) in day?.hours" :key="hourIndex" class="row col-md-7 text-center special-hour-entry">
                        <div class="special-schedules-container">
                            <div class="col-md-4 center special-hour-open" v-if="!day.closed">
                                <div class="center" style="color: #909090">
                                    Abre
                                    <b-form-input :disabled="!canEditSchedule()" type="time" min="0" class="input-schedule-2" v-model="hour.open"></b-form-input>
                                </div>
                            </div>
                            <div class="col-md-4 center special-hour-close" v-if="!day.closed">
                                <div class="center"  style="color: #909090; margin-left: 2rem">
                                    Cierra
                                </div>
                                <b-form-input :disabled="!canEditSchedule()" type="time" class="input-schedule-3" v-model="hour.close"></b-form-input>
                            </div>

                            <div class="col-md-1 my-auto hour-controls" v-if="!day.closed && canEditSpecialSchedule()">
                                <img @click="openModal(index)" src="@/assets/images/plus.png" alt="more" class="control-icon" />
                                <img @click="removeSpecialHoursList(index, hourIndex)" v-if="hourIndex > 0" src="@/assets/images/Delete.png" alt="delete" class="control-icon delete-icon" />
                            </div>
                        </div>
                    </div>
                    <div class="divider"></div>
                </div>
            </div>

            <div class="right box-button-save-changes" v-if="canViewSchedule()">
                <b-button href="#" type="submit" variant="success" @click="postSchedule" class="btn-success"
                    :disabled="!validSchedule">
                    Guardar Cambios
                </b-button>
            </div>
        </div>
    </Layout>
</template>


<style scoped>
@import '../../../design/views/schedules.scss';
</style>